import React from 'react';
import Svg from '../Svg';

const IconLineChartDown04 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00008 6C2.00008 3.79086 3.79094 2 6.00008 2H18.0001C20.2092 2 22.0001 3.79086 22.0001 6V14.9883C22.0002 14.9967 22.0002 15.005 22.0001 15.0134V18C22.0001 20.2091 20.2092 22 18.0001 22H6.00008C3.79094 22 2.00008 20.2091 2.00008 18V9.01164C1.99997 9.00332 1.99997 8.995 2.00008 8.98667V6ZM4.00008 10.9432V18C4.00008 19.1046 4.89551 20 6.00008 20H18.0001C19.1046 20 20.0001 19.1046 20.0001 18V15.5146L14.1082 11.3061L11.0067 14.4076C10.4882 14.9261 9.67085 14.9937 9.07417 14.5675L4.00008 10.9432ZM20.0001 13.0568V6C20.0001 4.89543 19.1046 4 18.0001 4H6.00008C4.89551 4 4.00008 4.89543 4.00008 6V8.48538L9.89198 12.6939L12.9935 9.5924C13.512 9.0739 14.3293 9.00626 14.926 9.43246L20.0001 13.0568Z"
    />
  </Svg>
);

export default IconLineChartDown04;
